declare global {
  interface HTMLElementEventMap {
    selectionend: CustomEvent;
  }
}

export interface SelectionRange {
  start: { x: number; y: number };
  end: { x: number; y: number };
}
const defaultRange = { start: { x: -1, y: -1 }, end: { x: -1, y: -1 } };
let selectionEndTimeout: NodeJS.Timeout | undefined = undefined;
let selectionRange: SelectionRange = defaultRange;

export const bindSelectionEndEvent = (el?: HTMLElement) => {
  ["mousedown", "mouseup", "selectionchange"].map(e => {
    (el || document).addEventListener(e.toString(), (evt /*event*/) => {
      if (selectionEndTimeout && evt.type === "selectionchange") {
        clearTimeout(selectionEndTimeout);
      }

      if (evt.type === "mousedown") {
        const { x, y } = evt as MouseEvent;
        selectionRange.start = { x, y };
      }
      selectionEndTimeout = setTimeout(function () {
        if (evt.type === "mouseup" && window.getSelection()?.toString() !== "") {
          const { x, y } = evt as MouseEvent;
          selectionRange.end = { x, y };

          (el || document).dispatchEvent(
            new CustomEvent("selectionend", { detail: { selectionRange } })
          );
          selectionRange = defaultRange;
        }
      }, 100);
    });
    return e; // Return the event name to satisfy the map callback requirement
  });
};
